export enum RegraCondicao {
    MAIOR = "Maior que",
    MENOR = "Menor que",
    IGUAL = "Igual a",
    ALTERADA = "Alterada",
    VAZIA = "Vazia"
}
